import ZoomProvider from "./ZoomProvider ";
import GoogleProvider from "./GoogleMeetProvider";

export function getProvider(providerKey) {
  switch (providerKey) {
    case "zoom":
      return ZoomProvider;
    case "google":
      return GoogleProvider;
    default:
      throw new Error("Unsupported provider");
  }
}
